import PropTypes from 'prop-types';
import React from 'react';
import Flexbox from 'flexbox-react';
import { cx, css } from 'emotion';
import { colorLightOrange } from 'styles/base';

const warningIconStyle = css`
    font-weight: normal;
    color: ${colorLightOrange};
`;
const headerTextStyle = css`
    font-weight: normal;
    font-size: 13px;
    color: grey;
    margin-left: 8px;
    line-height: 16px;
    font-style: italic;
`;

export default class InfoBoxPageHeader extends React.Component {
    static propTypes = {
        message: PropTypes.any,
        className: PropTypes.string
    };


    render() {
        return (
            <Flexbox flexDirection="row" alignItems="center" margin="15px" className={this.props.className}>
                <i className={cx(warningIconStyle, 'fa fa-lg fa-exclamation-triangle')} />
                <div className={headerTextStyle}>{this.props.message}</div>
            </Flexbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/InfoBoxPageHeader.js